import { render, staticRenderFns } from "./MasterBags.vue?vue&type=template&id=7dceb200"
import script from "./MasterBags.vue?vue&type=script&lang=js"
export * from "./MasterBags.vue?vue&type=script&lang=js"
import style0 from "./MasterBags.vue?vue&type=style&index=0&id=7dceb200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports